import React, { Component } from 'react';
import 'css/ViewCampaignListItem.scss';
import { CAMPAIGN_IMAGE_PATH } from 'constants/appConfig';
import { browserHistory } from 'react-router';

export default class ViewCampaignListItem extends Component {
    onClickHandler() {
        browserHistory.push('/sport/kampagner/' + this.props.campaign.seo_url);
    }

    render() {
        const { campaign } = this.props;

        const rules = campaign.rules ? (
            <div
                className="rules"
                dangerouslySetInnerHTML={{ __html: campaign.rules }}
            />
        ) : null;

        return (
            <div
                className="view-campaign-list-item-content"
                onClick={this.onClickHandler.bind(this)}
            >
                {campaign.image ? (
                    <img
                        src={CAMPAIGN_IMAGE_PATH + campaign.image}
                        alt={campaign.title}
                        width="100%"
                    />
                ) : null}
                <div className="content-container">
                    <div className="text-content-block">
                        <h3 className="campaign-title">{campaign.title}</h3>
                        {campaign.teaser ? (
                            <div
                                className="campaign-teaser"
                                dangerouslySetInnerHTML={{
                                    __html: campaign.teaser,
                                }}
                            />
                        ) : null}
                    </div>
                    {rules}
                </div>
            </div>
        );
    }
}
